/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { useLabels } from '@/hooks/useLabels';
import styles from './styles.module.scss';

export const Free = () => {
  const labels = useLabels({
    lblFree: 'label_checkout_shipping_Free',
  });
  return <span className={styles.freeLabel}>{labels.lblFree}</span>;
};
